export type ChristmasContact = {
  id: string;
  lang: 'es' | 'en';
  heading: string;
  name: string;
  phoneLabel: string;
  phoneDisplay: string;
  phoneE164: string;
  callLabel: string;
  textLabel: string;
  callAria: string;
  textAria: string;
};

export const christmasContacts: ChristmasContact[] = [
  {
    id: 'wilmer',
    lang: 'es',
    heading: 'Consultas en español',
    name: 'Wilmer',
    phoneLabel: 'Teléfono',
    phoneDisplay: '706-908-8791',
    phoneE164: '+17069088791',
    callLabel: 'Llamar',
    textLabel: 'Enviar mensaje',
    callAria: 'Llamar a Wilmer al 706-908-8791',
    textAria: 'Enviar mensaje a Wilmer al 706-908-8791',
  },
  {
    id: 'yoskar',
    lang: 'en',
    heading: 'English inquiries',
    name: 'Yoskar',
    phoneLabel: 'Phone',
    phoneDisplay: '(803) 270-7435',
    phoneE164: '+18032707435',
    callLabel: 'Call',
    textLabel: 'Text',
    callAria: 'Call Yoskar at (803) 270-7435',
    textAria: 'Text Yoskar at (803) 270-7435',
  },
];

// Contact shown in the Home page header bar.
export const homeHeaderContact: ChristmasContact = {
  id: 'wilmer-home',
  lang: 'en',
  heading: 'Free Quote',
  name: 'Wilmer',
  phoneLabel: 'Phone',
  phoneDisplay: '706-908-8791',
  phoneE164: '+17069088791',
  callLabel: 'Call',
  textLabel: 'Text',
  callAria: 'Call Wilmer for a free quote at 706-908-8791',
  textAria: 'Text Wilmer for a free quote at 706-908-8791',
};

// Where the Christmas page "Get a Free Quote" buttons go.
export const christmasQuoteHref = '#christmas-estimate';
